import React from 'react';
import { Autocomplete as TPAAutocomplete, type AutocompleteProps as TPAAutocompleteProps } from '@wix/wix-ui-tpa';
import { type DeviceTypeEnum } from '../../../../types/DeviceType';
import * as styleSheet from './styles.st.css';

interface AutocompleteProps {
  appearance: DeviceTypeEnum;
}

export const Autocomplete = (props: AutocompleteProps & TPAAutocompleteProps) => {
  const { appearance, ...restProps } = props;

  return (
    <TPAAutocomplete
      {...restProps}
      className={styleSheet.st(styleSheet.classes.root, {
        mobile: props.appearance === 'mobile',
        invalid: props.error,
      })}
    />
  );
};

Autocomplete.displayName = 'Autocomplete';
